import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';

export interface SupportTemplateItem {
  key: string;
  question: string;
  answer: string;
  route: string | null;
  sort_order: number;
  answer_kind: string;
}

export interface SupportTemplateCategory {
  key: string;
  title: string;
  sort_order: number;
  items: SupportTemplateItem[];
}

interface SupportTemplatesApiResponse {
  data?: { categories?: SupportTemplateCategory[] };
  categories?: SupportTemplateCategory[];
}

/** Items the analyst widget must not offer as buttons. */
export function prepareHelpBotCategories(
  categories: SupportTemplateCategory[] | null | undefined,
): SupportTemplateCategory[] {
  return [...(categories || [])]
    .map((category) => ({
      ...category,
      items: [...(category?.items || [])]
        .filter((item) => item?.answer_kind !== 'custom_later')
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)),
    }))
    .filter((category) => category.items.length > 0)
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
}

@Injectable({
  providedIn: 'root',
})
export class SupportTemplatesService {
  constructor(private http: HttpClient) {}

  getTemplates(): Observable<SupportTemplateCategory[]> {
    return this.http
      .get<SupportTemplatesApiResponse>(
        `${environment.baseUrl}/support/templates`,
      )
      .pipe(
        map((response) => {
          const categories =
            response?.data?.categories ?? response?.categories ?? [];
          return Array.isArray(categories) ? categories : [];
        }),
      );
  }
}
